module.exports = __webpack_public_path__ + "assets/media/birthday.408821e6.mp3";